import { createContext } from 'react'
import {
  IAgentSkill,
  IAgentTourSkill,
  IMeetupPlace,
  IConnectionMailTemplate,
} from 'static/interfaces'

export interface IInitialData {
  skills: IAgentSkill[]
  tour_skills: IAgentTourSkill[]
  meetup_places: IMeetupPlace[]
  connection_mail_templates: IConnectionMailTemplate[]
}

export interface IStaticDataStore {
  getSkills: () => IAgentSkill[]
  getTourSkills: () => IAgentTourSkill[]
  getMeetupPlaces: () => IMeetupPlace[]
  getConnectionMailTemplates: () => IConnectionMailTemplate[]
}

export const StaticContext = createContext<IStaticDataStore>({
  getSkills: () => [],
  getTourSkills: () => [],
  getMeetupPlaces: () => [],
  getConnectionMailTemplates: () => [],
})
